import { ref, readonly } from 'vue'

export const useAreas = (prefecturesStore, initial, master, clearAreas) => {
  const areas = ref(structuredClone(initial))

  const get = (areaId) => {
    return areas.value[areaId]
  }

  const set = (areaId, value) => {
    areas.value[areaId] = value
    prefecturesStore.set(areas.value)
  }

  const reset = () => {
    areas.value = structuredClone(initial)
    prefecturesStore.reset()
  }

  const clear = () => {
    areas.value = structuredClone(clearAreas)
    prefecturesStore.clear()
  }

  return { areas: readonly(areas), master: readonly(master), get, set, reset, clear }
}